import type { ReactNode } from 'react'
import { NotFoundView } from '#src/components/NotFoundView.js'
import { fetchPageMeta } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import CareersPage from '#src/pages/careers/CareersPage.js'
import { getCareersPageData } from '#src/pages/careers/careersPageData.js'
import { mergeMeta } from '#src/seo.js'
import type { Route } from './+types/careers.route.js'

export async function loader({ request }: Route.LoaderArgs) {
  const lang = languageService.langFromRequest(request)
  const [data, meta] = await Promise.all([
    getCareersPageData(lang),
    fetchPageMeta('careersPage', lang, '/careers'),
  ])
  return { data, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return mergeMeta(matches[0].meta, loaderData?.meta || [])
}

export default function Careers({ loaderData }: Route.ComponentProps): ReactNode {
  if (!loaderData.data) {
    return <NotFoundView />
  }

  return <CareersPage data={loaderData.data} />
}
